module.exports = __webpack_public_path__ + "static/media/m_beard_long_long__square_shadow.4da17556.png";